import FeaturedNewsContainer from './FeaturedNewsContainer';

export default FeaturedNewsContainer;
